import React, { useState } from "react";
import { Link } from "react-router-dom";
import MegaMenu from "./mega-menu/MegaMenu";
import MegaMenuMobile from "./mega-menu/MegaMenuMobile";

const HeaderThree = () => {
  const [navbar, setNavbar] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 68) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

 // var user = JSON.parse(localStorage.getItem('user'));

  window.addEventListener("scroll", changeBackground);

  return (
    <>
      <div
        className={
          navbar
            ? "theme-main-menu sticky-menu theme-menu-two bg-none fixed"
            : "theme-main-menu sticky-menu theme-menu-two bg-none"
        }
      >
        <div className="d-flex align-items-center justify-content-center">
          <div className="logo">
            <Link to="/">
            <img src="images/logo/logo.png" alt="weco logo" className="logo-weco"/>
            </Link>
          </div>
          {/* End Logo */}

          <nav id="mega-menu-holder" className="navbar navbar-expand-lg">
            <div className="container nav-container">
              <div
                className="navbar-collapse collapse"
                id="navbarSupportedContent"
              >
                <div className="d-lg-flex justify-content-between align-items-center">
                  <MegaMenu />
                  {/* End MegaMenu */}

                  <ul className="right-widget">
                    <li className="d-sm-flex">
                      <ul className="user-login-button d-flex align-items-center justify-content-center">
                        <li>
                        <Link to="#"
                              onClick={(e) => {
                                window.location.href = 'https://weco.beatdata.it';
                                e.preventDefault();
                            }} 
                           className="signIn-action">
                            Login
                          </Link>
                        {/* !user && <Link to="login"
                            className="signIn-action">
                            
                            Area Partner
                          </Link> */}
                          {/* user && <Link to="logout"
                            className="signIn-action">
                            
                            Logout
                        </Link> */}
                         
                        </li>
                        <li>
                          <Link to='#'
                            onClick={(e) => {
                                window.location.href = 'mailto:weco@beatdata.it';
                                e.preventDefault();
                            }} 
                            className="signUp-action">
                            Contattaci
                          </Link>
                        </li>
                      </ul>
                      {/* End ul */}
                    </li>
                  </ul>
                  {/* End right-button-group  */}
                </div>
              </div>
            </div>
          </nav>
          {/* End nav */}
        </div>

        <MegaMenuMobile />
        {/* 	End Mega Menu for Mobile */}
      </div>
      {/* /.theme-main-menu */}
    </>
  );
};

export default HeaderThree;
